import * as Phaser from "phaser-ce"
import { Scale } from "../utils/Scale"
import { GenericAssets } from "./GenericAssets"

export class SmokeSprite extends Phaser.Sprite {

    private smokeAnim: Phaser.Animation

    constructor(game: Phaser.Game, x: number, y: number, scale = 1, group?: Phaser.Group) {
        super(game, x, y, GenericAssets.SMOKE)

        if (group) {
            group.add(this)
        } else {
            game.add.existing(this)
        }
        Scale.scaleSprite(this, scale)

        this.smokeAnim = this.animations.add("smoke", [0, 1, 2, 1])

        this.alpha = 0
    }

    randomDelayedSmoke = () => {
        const delayTimer = this.game.time.create()
        const delay = Math.random() * 1000
        delayTimer.add(delay, () => {
            this.smoke()
        })
        delayTimer.start()
    }

    smoke = () => {
        this.alpha = 1
        this.smokeAnim.play(2, true)
    }

    stopSmoking = () => {
        this.animations.stop()
        this.animations.frame = 0
        this.alpha = 0
    }
}
